"use client";

import { trpcApi } from "@lattice/frontend/lib/trpc/client/index";
import TradeSummaryChart from "@lattice/frontend/components/charts/trade-summary-chart";
import StockInsiderTradesTable from "./stock-insider-trades-table";

export default function StockInsiderTradesChart({
  symbol,
  view,
}: {
  symbol: string;
  view: "table" | "chart";
}) {
  const [data] = trpcApi.stock.get_insider_trades.useSuspenseQuery(
    {
      symbol,
    },
    { refetchOnMount: false },
  );

  if (!data.length)
    return (
      <div className="h-[600px] flex items-center justify-center text-muted-foreground">
        No data available
      </div>
    );

  return (
    <div className="relative">
      {view === "table" ? (
        <StockInsiderTradesTable data={data} />
      ) : (
        <TradeSummaryChart
          data={data.map((d) => ({
            id: d.id,
            amount: d.securitiesTransacted,
            isBuy: d.acquisitionOrDisposition === "A",
            isSell: d.acquisitionOrDisposition === "D",
            transactionDate: d.transactionDate,
          }))}
        />
      )}
    </div>
  );
}
